import { DateTime } from 'luxon';
import { serverUri } from '../../../App';
import ErrorPage from '../../../pages/common/ErrorPage';
import React, { ErrorInfo } from 'react';
import axios from 'axios';

type Props = {
    children: React.ReactNode;
};

type State = {
    error: Error | null;
    errorInfo: ErrorInfo | null;
};

export default class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error: any) {
        return { error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        const { message, stack } = error;

        const dt = DateTime.local().toString();
        const frontendLog = {
            message,
            stackTrace: stack,
            browser: navigator.userAgent,
            dateTime: dt,
        };
        console.log(frontendLog);
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
        axios
            .post(serverUri + '/api/log', {
                message: frontendLog,
            })
            .then(
                (response) => {
                    console.log(response);
                },
                (error) => {
                    console.log(error);
                },
            );
        console.error(JSON.stringify(error));
        console.error(errorInfo);
    }

    render() {
        const { errorInfo } = this.state;
        const { children } = this.props;
        if (errorInfo) {
            return <ErrorPage />;
        }
        return children;
    }
}
